import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { TextReveal } from './TextReveal';
export function Intro() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: '-10%'
  });
  return <section ref={sectionRef} className="md:py-32 bg-bg pt-[68px] pb-[68px]" data-id="element-53">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8,
      delay: 1.5,
      ease: [0.25, 0.36, 0.45, 0.94]
    }} data-id="element-54">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl" data-id="element-55">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-56">
            <div className="md:col-span-3" data-id="element-57">
              <TextReveal text="ÜBER   UNS" as="h2" className="text-xs md:text-sm font-mono uppercase tracking-[0.3em] text-muted sticky top-32" delay={1} data-id="element-58" />
            </div>

            <div className="md:col-span-9" data-id="element-59">
              <TextReveal text="Wir beraten Geschäftsführer und Gesellschafter bei der Gründung,  Strukturierung und Optimierung ihrer GmbH." as="p" className="text-2xl md:text-4xl font-bold leading-tight text-white max-w-4xl" delay={1.1} data-id="element-60" />

              <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-61">
                <div data-id="element-62">
                  <TextReveal text="Unsere Philosophie ist radikal einfach: Wir konzentrieren uns auf das Wesentliche. In einer komplexen Welt schaffen wir Klarheit durch Struktur und kompromisslose Qualität." as="p" className="text-muted text-lg leading-relaxed" delay={1.4} data-id="element-63" />
                </div>
                <div data-id="element-64">
                  <TextReveal text="Mit jahrelanger Erfahrung im Gesellschaftsrecht und der strategischen Unternehmensführung sind wir der Partner, der nicht nur berät, sondern unternehmerisch mitdenkt." as="p" className="text-muted text-lg leading-relaxed" delay={1.6} data-id="element-65" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}